import { startOfDay } from 'date-fns';

import { DatePickerDate } from '../types';

export default function isSelected(
  selectedDates: (DatePickerDate | null)[] | null,
  date: DatePickerDate,
) {
  if (!selectedDates) {
    return false;
  }

  return selectedDates.some((selectedDate) => {
    if (
      selectedDate instanceof Date &&
      startOfDay(selectedDate).getTime() === startOfDay(date).getTime()
    ) {
      return true;
    }
    return false;
  });
}
